import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./styles/card.module.css";

const Card = (props) => {
  const { icon, title, body } = props;
  return (
    <div className={styles["card"]}>
      <div className={styles["card-container"]}>
        <div className={styles["card-header"]}>
          <div className={styles["card-icon"]}>
            <FontAwesomeIcon icon={icon} />
          </div>
          <div className={styles["card-title"]}>{title}</div>
        </div>
        <div className={styles["card-body"]}>
          <div>{body}</div>
        </div>
      </div>
    </div>
  );
};

export default Card;
